import { EyeOutlined } from '@ant-design/icons';
import { useMemoizedFn } from 'ahooks';
import { Image } from 'antd';
import { useOrgConfigStateValue } from 'hooks/business/useOrgConfig';
import { getImageThumb, getTiktokProxyImageSrc } from 'lib/utils/platformImage';
import { useMemo } from 'react';
import { toUpperCase } from 'utils/toLowerCase';

interface ProductInfoImageProps {
  imgUrl: string;
  itemName: string;
  size?: number;
  platform?: General.PlatformUpperCaseTunnel | General.Platform;
}

export const ProductInfoImage = (props: ProductInfoImageProps) => {
  const { imgUrl, itemName, size = 48, platform } = props;

  const imageSize = size - 2;

  const { tiktokImageProxyOriginList } = useOrgConfigStateValue();

  const getFastImage = useMemoizedFn((image: string) => {
    if (tiktokImageProxyOriginList?.some((origin) => image.includes(origin))) {
      return getTiktokProxyImageSrc(image);
    }
    return image;
  });

  const thumbnailImage = useMemo(
    () => getImageThumb(imgUrl, toUpperCase(platform)),
    [imgUrl, platform],
  );

  const fastOriginalImage = useMemo(() => getFastImage(imgUrl), [imgUrl, getFastImage]);
  const fastThumbnailImage = useMemo(
    () => getFastImage(thumbnailImage),
    [thumbnailImage, getFastImage],
  );

  return (
    <div
      className="relative rounded-[2px] overflow-hidden border border-solid border-[#F0F2F5] flex-shrink-0"
      style={{ width: size, height: size }}
    >
      <Image
        src={fastThumbnailImage}
        alt={itemName}
        width={imageSize}
        height={imageSize}
        className="object-cover"
        preview={{
          mask: <EyeOutlined />,
          src: fastOriginalImage,
        }}
      />
    </div>
  );
};
